export const quizQuestions = [
  {
    id: "question5",
    videoId: "video5",
    topic: "Following Distance",
    question: "Whenever there is a car in front of me: ",
    options: [
      "I need to follow the 2 or 3 second rule",
      "Always tailgate to avoid collision",
      "Overtake the car in front",
    ],
    correctAnswer: "I need to follow the 2 or 3 second rule",
    descriptionTitle: "Following Distance",
    description1:
      "Following distance is one of the most important lessons that we need to learn when driving a vehicle. It is important not to follow another car too close as we will have a very minimal time to react. In order to implement this effectively, we must follow the TWO or THREE second rule. This means that we should allow a 2 or 3 second measurement of distance between the front vehicle and our vehicle. Measuring the distance with our eyes is hard but counting 3 seconds is a better option. ",
  },
];
